import $ from "jquery";
import { config } from "src/config/config";
import { setupXhr } from "../utils";

export const GetBinaryRequest = (
  url: string,
  data?: any,
  headers?: any,
  progress?: any
): JQuery.Promise<any> => {
  return $.ajax({
    url,
    method: "GET",
    dataType: "binary",
    processData: false,
    cache: false,
    data: data !== "undefined" ? data : {},
    headers: headers !== "undefined" ? headers : {},
    timeout: config.AJAX_GET_TIMEOUT,
    xhrFields: {
      responseType: "arraybuffer",
    },
    xhr: function () {
      return setupXhr(progress);
    },
    beforeSend: function (jqXHR, settings) {
      if (settings.dataType === "binary") {
        if (settings.xhr) {
          settings.xhr().responseType = "arraybuffer";
        }
      }
    },
  });
};
